var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecurringIcon = function SvgRecurringIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M11.98 13H6v-2h6v.004h1.98a2 2 0 0 1-2 2zM2.02 3H8v2H2v-.004H.02a2 2 0 0 1 2-2zM0 5h2v4l-2 2zm8-5 4 4-4 4zm6 11h-2V7l2-2zm-8 5-4-4 4-4z"
  })));
};
export default SvgRecurringIcon;